import { PageComponents, DeskPageBodyComponents, ButtonType } from '@my-types';
import { React } from '@common/3rd';
import { Utils, Storage, Apis, Ajax, PATH, Envs } from '@common';
import { DeskPage, DeskPageBody, DeskButton, DeskImage, DeskPanel } from '@desk-component';
import Alert from '@alert';
import Dialog from '@dialog';
import EnterpriseExclusive from './enterprise-exclusive/enterprise-exclusive'
import 'swiper/swiper-bundle.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay, Navigation, Pagination } from 'swiper';
SwiperCore.use([Autoplay, Navigation, Pagination]);
/**
 * 桌面首页
 */
class DeskHome extends DeskPage<any, any, PageComponents & DeskPageBodyComponents> {
	bodyRef: React.RefObject<any>;
	constructor(props: any) {
		super(props);
		this.state = {
			bannerList: [],
			entInfoBannerList: [],
            entInfoProductList: [],
			salesRankTitle: '',
			salesRankList: [], // 销量排行
			selectionTitle: '',
			selectionList: [], // 美世严选
			cooperationTitle: '',
			cooperationList: [], // 合作保司
			finished: false
		};
		this.bodyRef = React.createRef();
		this.loadThirdModule();
	}

    removeThirdModule() {
        document.getElementById('udesk_container')?.setAttribute("style", "display:none");
        if (document.getElementById('udesk_container') && document.getElementsByClassName("udesk-client-btn").length > 0) {
            let udeskContainerCss = document.getElementsByClassName("udesk-client-btn")[0].getAttribute("style");
            if (!Utils.isBlank(udeskContainerCss)) {
                const noneUdeskContainerCss = (udeskContainerCss as string).replace("display:block", "display:none") as string;
                document.getElementsByClassName("udesk-client-btn")[0].setAttribute("style", noneUdeskContainerCss);
            }
        }
    }

    loadThirdModule() {
        if (this.tenantCode === 'MEJ') {
            //udesk plugin
            //@ts-ignore
            (function (a, h, c, b, f, g) { a["UdeskApiObject"] = f; a[f] = a[f] || function () { (a[f].d = a[f].d || []).push(arguments) }; g = h.createElement(c); g.async = 1; g.charset = "utf-8"; g.src = b; c = h.getElementsByTagName(c)[0]; c.parentNode.insertBefore(g, c) })(window, document, "script", "//assets-cli.udesk.cn/im_client/js/udeskApi.js", "ud");
            //@ts-ignore
            ud({
                "code": "2f6e3h21",
                "link": "https://mej.udesk.cn/im_client/?web_plugin_id=56871",
				"css": {
					"height": "34px",
					"padding": "7px",
					"line-height": "20px",
					"bottom": "65px"
				}
            });
            setTimeout(() => {
                document.getElementById('udesk_container')?.setAttribute("style", "display:block");
                if (document.getElementById('udesk_container') && document.getElementsByClassName("udesk-client-btn").length > 0) {
                    let udeskContainerCss = document.getElementsByClassName("udesk-client-btn")[0].getAttribute("style");
                    if (!Utils.isBlank(udeskContainerCss)) {
                        const blockUdeskContainerCss = (udeskContainerCss as string).replace("display:none", "display:block") as string;
                        document.getElementsByClassName("udesk-client-btn")[0].setAttribute("style", blockUdeskContainerCss);
                    }
                }
            }, 100);
        }
    }
	componentWillUnmount() {
        this.removeThirdModule();
    }
	async componentDidMount(): Promise<void> {
		try {
			await super.componentDidMount();
			const account = Envs.findAccount();
			let organInSession = Storage.Last.session().get('organ');
			let params: {[propName: string]: any} = {
				tenantCode: account.tenantCode || this.tenantCode,
				configType: "SALES_CONFIG", // 不在使用数字"3",使用英文字母组合
				status: 1
			};
			if ((Envs.findAccount().hasOwnProperty('showMall') && !Envs.findAccount().showMall)) { // 企业精选模式
			} else {
				let res = await this.getHelpers().getAjax().post(Apis.TENANT_CONFIGURATION_LIST, params, { loading: true });
				// console.log(res)
				if (res?.body?.body && res.body.body.length) {
					let configList: {[propName: string]: any}[] = res.body.body;
					let bannerObj = Utils.getConfigFromRes(configList, { detailConfigType: '1' }),
						saleRankObj = Utils.getConfigFromRes(configList, { detailConfigType: '2' }),
						selectionObj = Utils.getConfigFromRes(configList, { detailConfigType: '3' }),
						cooperationObj = Utils.getConfigFromRes(configList, { detailConfigType: '4' });
					this.setState({
						bannerList: bannerObj.list,
						salesRankTitle: saleRankObj.title,
						salesRankList: saleRankObj.list,
						selectionTitle: selectionObj.title,
						selectionList: selectionObj.list,
						cooperationTitle: cooperationObj.title,
						cooperationList: cooperationObj.list
					});
				}
			}
			if (organInSession?.organCode) {
				// console.log(organInSession.organCode);
				params.organCode = organInSession.organCode;
				let organRes = await this.getHelpers().getAjax().post(Apis.TENANT_CONFIGURATION_LIST, params, {loading: true});
				if (organRes?.body?.body && organRes.body.body.length) {
					let configList: {[propName: string]: any}[] = organRes.body.body;
					let entObj = Utils.getConfigFromRes(configList, { detailConfigType: '5', isOgran: true });
					if (entObj?.list && entObj.list.length) {
						let obj = entObj.list[0];
						this.setState({
							entInfoBannerList: obj.banners,
                            entInfoProductList: obj.products
						});
						Storage.Last.session().set('organ', {
							...organInSession,
							logo: obj.logo1 || '',
							colorTheme: obj.colorTheme1 || '2' // 顶部UI配色根据企业Logo可切换深色（1）、浅色（2）两种，默认为浅色
						});
						this.reRenderHeader();
					}
				}
			}
			if (this.bodyRef?.current) {
				this.bodyRef.current.reRenderMenu();
			}
		} catch (e) {
		} finally {
			this.setState({
				finished: true
			});
		}
	}
	getEntProductList = (list: any[]) => {
		let account = Envs.findAccount();
		Envs.holdAccount({
			...account,
			entProductCount: list.length
		});
		this.reRenderHeader();
	}
	closeAllMouseOver() {
        if (this.state.entInfoProductList?.length) {
            (this.state.entInfoProductList as any[]).forEach(i => {
                this.handleMouseLeave(i, 'entInfoProductList');
            })
        }
        if (this.state.salesRankList?.length) {
            (this.state.salesRankList as any[]).forEach(i => {
                this.handleMouseLeave(i, 'salesRankList');
            });
        }
        if (this.state.selectionList?.length) {
            (this.state.selectionList as any[]).forEach(i => {
                this.handleMouseLeave(i, 'selectionList');
            })
        }
    }
	renderPageBody() {
		const C = this.getComponents();
		return <DeskPageBody ref={this.bodyRef} tenantCode={this.tenantCode} where="首页" css={() => `background: #fff;`} vendor={this.props?.vendor}>
			{this.state.bannerList.length && !(Envs.findAccount().hasOwnProperty('showMall') && !Envs.findAccount().showMall) ? 
			/* @ts-ignore */
			<Swiper modules={[Autoplay, Navigation, Pagination]} observer={true} observeParents={true}
					autoplay={this.state.bannerList.length > 1 ? { delay: 3000 } : false} loop={true} navigation pagination={{ clickable: true }} className="top-swiper" style={{marginBottom: '38px'}}
			>
				{(this.state.bannerList as any[]).map((item, index) => {
					return <SwiperSlide key={`swiper_${index}`}>
						<div style={{display:'flex',justifyContent:'center'}} onClick={async () => {
							if (item.category === '1') {
								await this.handleMouseOver(item, 'bannerList');
								// let dialogRef = Dialog.show(item?.productInfo?.advertisementName, <DeskPanel css={() => `align-items: center;img {width: 200px;margin-top: 10px;}`}>
								// 	<img src={item.qrcode} alt="" />
								// </DeskPanel>,
								// <DeskButton
								// 	type={ButtonType.PRIMARY}
								// 	label="关闭" css={() => `margin-top: 20px;width: 150px;`}
								// 	onClick={() => {
								// 		Dialog.hide(dialogRef);
								// 	}}
								// />,
								// {
								// 	boxCSS: {width: '400px', top: '10vh', padding: '40px'},
								// 	headerCSS: () => `[data-widget="dialog-header-title"]{font-size: 14px;}
								// 	& > div:nth-child(2) {position: absolute;right: 10px;top:10px;font-size:3em;}`
								// });
							} else if ((item.category === '2' || item.category === '3') && item.thirdUrl && Utils.isValidHttpUrl(item.thirdUrl)) {
								if(item.thirdFlag === true ){
									Alert.ask('即将跳转外部链接').then(() => {
										window.open(item.thirdUrl, '_blank');
									});
								}else{
									window.open(item.thirdUrl, '_blank');
								}
							}
						}}>
							<DeskImage src={item.image} alt="" css={() => `height: calc(440px / ${window.devicePixelRatio});`} />
						</div>
					</SwiperSlide>
				})}
			</Swiper> : null}
			{/* 非企业用户不显示企业精选信息 */}
			{this.state.finished && Envs.findAccount().sourceType !== '1' && Storage.Last.session().get('organ') ? <DeskPanel css={() => `
				[data-widget="desk-page"] {min-height: 0;}
				[data-widget="desk-page-header"] {display: none;}
				[data-widget="page-footer"] {display: none;}
				[data-widget="page-body"] {
					min-height: 0;
					margin-top: 0;
					background: #fff;
					padding-bottom: 0;
					> div {
						margin-top: 0;
					}
				}
			`}>
				<EnterpriseExclusive useInHome={true} onlyEnterprise={Envs.findAccount().hasOwnProperty('showMall') && !Envs.findAccount().showMall}
									 productListInConfig={this.state.entInfoProductList} onGetProductList={this.getEntProductList} vendor={this.props?.vendor}
				/>
			</DeskPanel> : null}
			{Envs.findAccount().hasOwnProperty('showMall') && !Envs.findAccount().showMall ? null : <>
			{this.state.entInfoProductList.length ? 
			<C.ContentWrapper css={() => `margin-top:0;`}>
				<div></div>
				{(this.state.entInfoProductList as any[]).map((item, index) => {
					return <C.Product key={`ent_product_${index}`} onClick={() => {
						if (item.qrcode) {
							this.handleMouseLeave(item, 'entInfoProductList');
						} else {
							this.closeAllMouseOver();
							this.handleMouseOver(item, 'entInfoProductList');
						}
					}}>
						<div>
							<C.Overall className={item.showOverall ? 'show' : ''}>
								<div>
									{item.qrcode ? <img className="qrcode" src={item.qrcode} alt="" /> : null}
									<p>手机扫码至移动端查看详情</p>
								</div>
							</C.Overall>
							<DeskImage src={item?.image} alt="" css={() => `width: 100%;`} />
						</div>
						<div>
							<div className="item-title" title={item?.productInfo?.advertisementName}>{item?.productInfo?.advertisementName}</div>
							{item?.productInfo?.vendorName ? <div className="item-vendor">{item?.productInfo?.vendorName}</div> : null}
							<div className="item-desc">
								{item?.productInfo?.slogan1 ? <p>{item?.productInfo?.slogan1}</p> : null}
								{item?.productInfo?.slogan2 ? <p>{item?.productInfo?.slogan2}</p> : null}
								{item?.productInfo?.slogan3 ? <p>{item?.productInfo?.slogan3}</p> : null}
							</div>
							<div className="item-premium">
								<C.Premium>
									<span>{item?.productInfo?.minPrice?.toLocaleString()}</span><span>元起</span>
								</C.Premium>
								<DeskButton type={ButtonType.PRIMARY}>
									查看详情
								</DeskButton>
							</div>
						</div>
						<C.SupTip>企业精选</C.SupTip>
					</C.Product>
				})}
			</C.ContentWrapper> : null}
			<C.ContentWrapper>
				{this.state.salesRankTitle ? <div className="title">
					<span>{this.state.salesRankTitle}</span>
				</div> : null}
				{(this.state.salesRankList as any[]).map((item, index) => {
					return <C.Rank key={`sale_${index}`} onClick={() => {
						if (item.qrcode) {
							this.handleMouseLeave(item, 'salesRankList');
						} else {
							this.closeAllMouseOver();
							this.handleMouseOver(item, 'salesRankList');
						}
					}}>
						<C.Overall className={item.showOverall ? 'show' : ''}>
							<div>
								{item.qrcode ? <img className="qrcode" src={item.qrcode} alt="" /> : null}
								<p>手机扫码至移动端查看详情</p>
							</div>
						</C.Overall>
						<div>
							<span title={item?.productInfo?.advertisementName}>{item?.productInfo?.advertisementName}</span>
							<div className="item-desc">
								{item?.productInfo?.slogan1}
								{item?.productInfo?.slogan2 ? ` | ${item?.productInfo?.slogan2}` : null}
								{item?.productInfo?.slogan3 ? ` | ${item?.productInfo?.slogan3}` : null}
							</div>
							<div className="item-premium">
								<C.Premium css={(props) => `color: ${props.theme.COLOR_PRIMARY};>span:first-child{font-size: 32px;font-weight:600;}span:not(:first-child){font-size: 16px;}`}>
									<span>{item?.productInfo?.minPrice?.toLocaleString()}</span><span>元起</span>
								</C.Premium>
								<DeskButton type={ButtonType.PRIMARY} css={() => ``}>
									查看详情
								</DeskButton>
							</div>
						</div>
					</C.Rank>
				})}
			</C.ContentWrapper>
			<C.ContentWrapper>
				{this.state.selectionTitle ? <div className="title">
					<span>{this.state.selectionTitle}</span>
					<a className="link" onClick={() => {
						this.getHelpers().getRouter().pushRedirect(PATH.DESK2_PRODUCT_MAIN);
					}}>查看更多&gt;</a>
				</div> : null}
				{(this.state.selectionList as any[]).map((item, index) => {
					return <C.Product key={`selection_${index}`} onClick={() => {
						if (item.qrcode) {
							this.handleMouseLeave(item, 'selectionList');
						} else {
							this.closeAllMouseOver();
							this.handleMouseOver(item, 'selectionList');
						}
					}}>
						<div>
							<C.Overall className={item.showOverall ? 'show' : ''}>
								<div>
									{item.qrcode ? <img className="qrcode" src={item.qrcode} alt="" /> : null}
									<p>手机扫码至移动端查看详情</p>
								</div>
							</C.Overall>
							<DeskImage src={item?.image} alt="" css={() => `width: 100%;`} />
						</div>
						<div>
							<div className="item-title" title={item?.productInfo?.advertisementName}>{item?.productInfo?.advertisementName}</div>
							{item?.productInfo?.vendorName ? <div className="item-vendor">{item?.productInfo?.vendorName}</div> : null}
							<div className="item-desc">
								{item?.productInfo?.slogan1 ? <p>{item?.productInfo?.slogan1}</p> : null}
								{item?.productInfo?.slogan2 ? <p>{item?.productInfo?.slogan2}</p> : null}
								{item?.productInfo?.slogan3 ? <p>{item?.productInfo?.slogan3}</p> : null}
							</div>
							<div className="item-premium">
								<C.Premium>
									<span>{item?.productInfo?.minPrice?.toLocaleString()}</span><span>元起</span>
								</C.Premium>
								<DeskButton type={ButtonType.PRIMARY}>
									查看详情
								</DeskButton>
							</div>
						</div>
					</C.Product>
				})}
			</C.ContentWrapper>
			<C.ContentWrapper css={() => `padding-bottom: 20px;`}>
				{this.state.cooperationTitle ? <div className="title">
					<span>{this.state.cooperationTitle}</span>
				</div> : null}
				{this.state.cooperationList.length < 6 ?
					<div style={{display: 'flex'}}>
						{(this.state.cooperationList as any[]).map((item, index) => 
							<DeskImage src={item.image} alt={item.vendorName} key={`swiper_img_${index}`} css={() => `width: 162px;margin-right:24px;border-radius:10px;box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.05);`} />
						)}
					</div>
					:
					<div className="bottom-swiper-wrapper">
						<Swiper slidesPerView={6} observer={true} observeParents={true} autoplay={{ delay: 0, disableOnInteraction: false }} spaceBetween={0} speed={ 3000 } loop={true} className="img-swiper">
							{(this.state.cooperationList as any[]).map((item, index) => <SwiperSlide key={`swiper_img_${index}`}>
								<DeskImage src={item.image} alt={item.vendorName} css={() => `width: 162px;margin-right:24px;border-radius:10px;box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.05);`} />
							</SwiperSlide>)}
						</Swiper>
					</div>
				}
			</C.ContentWrapper></>}
		</DeskPageBody>
	}
}

export default DeskHome;
